export function useOfflineQueue() {
  return {
    enqueueCreateDraftIntent: async (...args: Parameters<typeof import("../offlineQueue").enqueueCreateDraftIntent>) => {
      const module = await import("../offlineQueue");
      return module.enqueueCreateDraftIntent(...args);
    },
    enqueueUpdateDraftIntent: async (...args: Parameters<typeof import("../offlineQueue").enqueueUpdateDraftIntent>) => {
      const module = await import("../offlineQueue");
      return module.enqueueUpdateDraftIntent(...args);
    },
    enqueueSubmitDraftIntent: async (...args: Parameters<typeof import("../offlineQueue").enqueueSubmitDraftIntent>) => {
      const module = await import("../offlineQueue");
      return module.enqueueSubmitDraftIntent(...args);
    },
    listPendingRequisitionIntents: async () => {
      const module = await import("../offlineQueue");
      return module.listPendingRequisitionIntents();
    },
  };
}
